import React, { useMemo, useEffect } from 'react';

import rtl from 'jss-rtl';
import { create } from 'jss';
import { useI18n } from 'circe/I18n';
import { MuiThemeProvider } from 'pencil/styles';
import createGenerateClassName from 'pencil/styles/createGenerateClassName';
import StylesProvider from 'pencil/styles/StylesProvider';
import jssPreset from 'pencil/styles/jssPreset';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const generateClassName = createGenerateClassName();

const ThemeProvider = ({ theme: providedTheme, children }) => {
  const { locale } = useI18n();

  const theme = useMemo(
    () => ({
      ...providedTheme,
      direction: locale.dir,
    }),
    [locale.dir],
  );

  useEffect(() => {
    document.body.dir = locale.dir;
  }, [locale.dir]);

  return (
    <StylesProvider jss={jss} generateClassName={generateClassName}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </StylesProvider>
  );
};

export default ThemeProvider;
